import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

// legacy .main-spinner SCSS -> MUI CircularProgress. Keeps the centred, 20px-padded
// container and the data-cy/data-testid/id selectors the app + cypress rely on; colour
// now comes from the theme primary instead of the hardcoded $blue-900.
export default function Spinner(): JSX.Element {
  return (
    <Box
      data-cy="loading-more-spinner"
      data-testid="loading-more-spinner"
      sx={{ py: 2.5, textAlign: "center" }}
    >
      <CircularProgress id="loading-more-spinner" color="primary" size={36} />
    </Box>
  );
}
